var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 162.67 139.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#New_Gradient_Swatch_8);}.cls-2{fill:#ffe500;}.cls-3{fill:#fff;}.cls-4{fill:#ffcc0d;}.cls-5{fill:#6b3e97;}.cls-6{fill:url(#radial-gradient);}.cls-7{fill:url(#radial-gradient-2);}.cls-8{fill:url(#radial-gradient-3);}.cls-9{fill:url(#radial-gradient-4);}.cls-10{fill:#27828c;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_8",
    cx: 361.77,
    cy: 620.05,
    r: 72.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5fb845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#51ae44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3a9d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#19863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11803c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 363.13,
    cy: 614.7,
    r: 93.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc3ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4bc0cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#46b7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3da8b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#31929d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27828c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 304.42,
    cy: 619.22,
    r: 139.83,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 341.49,
    cy: 631.34,
    r: 126.24,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 381.03,
    cy: 666.34,
    r: 38.23,
    xlinkHref: "#radial-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "YTV-4col") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.84,607.85C371,596.74,333.68,614.24,321.61,647s5.59,68.3,39.48,79.43,71.14-6.4,83.23-39.14S438.72,619,404.84,607.85Zm15.48,72.46a42.14,42.14,0,0,1-52.45,24.61,38.72,38.72,0,0,1-24.19-50.4,42.09,42.09,0,0,1,52.57-25.1A38.69,38.69,0,0,1,420.32,680.31Z",
    transform: "translate(-292.18 -597.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M438.91,665.09a56,56,0,1,1-58.63-53.3A56,56,0,0,1,438.91,665.09Z",
    transform: "translate(-292.18 -597.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M422.73,664.36c1.08,22.73-16.7,42-39.73,43.15s-42.6-16.44-43.68-39.18,16.71-42.06,39.74-43.15S421.64,641.62,422.73,664.36Z",
    transform: "translate(-292.18 -597.2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.46,664.52c1,20.94-15.4,38.75-36.63,39.76s-39.24-15.15-40.23-36.11,15.38-38.75,36.62-39.76S418.46,643.56,419.46,664.52Z",
    transform: "translate(-292.18 -597.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.14,684.8c-10.6,30-44.37,46.37-75.4,36.6s-47.59-42-37-71.94,44.36-46.36,75.41-36.61S449.76,654.83,439.14,684.8Zm-38.06-68.27c-28.56-9.57-60.14,5.58-70.51,33.68A51.94,51.94,0,0,0,363,717.8c28.21,9.5,59.69-5.2,70.34-33A51.9,51.9,0,0,0,401.08,616.53Z",
    transform: "translate(-292.18 -597.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.27,622c-3.4.6-7.54,4.45-9.45,7.83l5.87-18.91s-16.38,2.6-19.5,3.15-9.72,2.42-12,9.45L349.1,655.88c-1.59-1.44-18.17-17.47-19.82-19-4.29-4.06-7.93-4.56-12.85-3.88s-24.25,4.39-24.25,4.39,38.91,33.12,49.14,42c-1.9,6.92-16.73,51.94-16.73,51.94s15.53-2.12,20.7-3a16,16,0,0,0,11.5-8.58c.09-.18,4.88-15.5,10.81-34.57a12.1,12.1,0,0,0,2.47,5.1c1.85,2.41,16.24,20,16.4,20.15,4.38,4.52,7.8,4.77,11.85,4.2,0,0,12.66-2.15,13-2.23,4.58-1.06,7-3.16,9.48-8.79,1.57-3.39,20.89-59.19,20.89-59.19l-19.84,3.83c-6.34,1.11-7.82,4.51-8.63,6.08-1.81,4-10.71,30-14,39.58-2.45-3.07-21.21-26.92-24.65-31.28,1.63-5.22,3.23-10.4,4.78-15.35,2.93-.47,10.81-1.72,12.54-2-2.23,7-4.66,15.84-4.8,16.32a11.66,11.66,0,0,0,.74,8.37c1.42,3.25,12.67,14.5,12.67,14.5s13.14-35.51,16.38-43.23c2.19-.35,12.77-2.16,13.66-2.31,9.12-1.46,11.85-3.3,13.67-6.6,1.4-2.53,7.63-20.78,7.63-20.78S396.45,621.58,394.27,622Z",
    transform: "translate(-292.18 -597.2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.55,614.35l-15.79,2.74c-2.73.44-7.29,1.2-9,7.33-.87,3.3-11.41,34.87-11.41,34.87-.67.11-.79.06-1.11-.24-1.12-1-20.1-18.14-21.84-19.7-4.21-3.79-7.66-4-10.34-3.51l-18.54,3.23s37.21,31.77,46,39.47c-1.5,5.84-15.54,49.59-15.54,49.59s10-1.56,15.17-2.46a13.14,13.14,0,0,0,10.23-7.8Zm8.1,9.82c-2.72.48-7.12,4.57-8.41,7.81-1.17,2.95-4.62,12.6-4.62,12.6s10.47-1.66,13.63-2.2c-1.93,5.59-4.55,14.72-5.94,19.74a9.44,9.44,0,0,0,.62,6.86c1,2.47,9.81,11.73,9.81,11.73s12.56-34,15.93-41.85l15.94-2.66c6.83-1.22,9.06-2.38,10.52-5.42,1.18-2.46,5.3-15.8,5.3-15.8Zm27.58,26.24c-4.47.77-6,2.35-7,4.79-2,4.43-13,36.72-14.79,42.12-1,.21-1.3.21-2.49-1.46L374.9,666.48s-4.11,12.07-4.58,13.61c-.82,2.49-1.31,5,1.54,8.76,1.78,2.32,12.49,14.91,16.12,19,4,4.38,6.15,4.31,9.83,3.79l11.78-2c4.57-1,6.56-1.93,8.83-7,1.49-3.21,19-54.79,19-54.79Z",
    transform: "translate(-292.18 -597.2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M454.85,598.65c-92.79-8-119.54,18.88-130.18,38.6a64.44,64.44,0,0,0-4.32,9.33,61.52,61.52,0,0,0,12.08,62.8l-24.77,22.51c70.3,12.83,103.28-2.56,119.57-17.73a64.84,64.84,0,0,0,18.34-26.47,61.55,61.55,0,0,0-13.77-64.6Z",
    transform: "translate(-292.18 -597.2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M405.46,606.17c-34.85-11.43-73.17,6.58-85.59,40.25s5.75,70.23,40.6,81.67,73.15-6.58,85.59-40.24S440.29,617.61,405.46,606.17Zm15.92,74.51A43.33,43.33,0,0,1,367.45,706a39.81,39.81,0,0,1-24.88-51.82,43.3,43.3,0,0,1,54.05-25.83A39.8,39.8,0,0,1,421.38,680.68Z",
    transform: "translate(-292.18 -597.2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M438.91,665.09a56,56,0,1,1-58.63-53.3A56,56,0,0,1,438.91,665.09Z",
    transform: "translate(-292.18 -597.2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M422.73,664.36c1.08,22.73-16.7,42-39.73,43.15s-42.6-16.44-43.68-39.18,16.71-42.06,39.74-43.15S421.64,641.62,422.73,664.36Z",
    transform: "translate(-292.18 -597.2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M419.46,664.52c1,20.94-15.4,38.75-36.63,39.76s-39.24-15.15-40.23-36.11,15.38-38.75,36.62-39.76S418.46,643.56,419.46,664.52Z",
    transform: "translate(-292.18 -597.2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.14,684.8c-10.6,30-44.37,46.37-75.4,36.6s-47.59-42-37-71.94,44.36-46.36,75.41-36.61S449.76,654.83,439.14,684.8Zm-38.06-68.27c-28.56-9.57-60.14,5.58-70.51,33.68A51.94,51.94,0,0,0,363,717.8c28.21,9.5,59.69-5.2,70.34-33A51.9,51.9,0,0,0,401.08,616.53Z",
    transform: "translate(-292.18 -597.2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.27,622c-3.4.6-7.54,4.45-9.45,7.83l5.87-18.91s-16.38,2.6-19.5,3.15-9.72,2.42-12,9.45L349.1,655.88c-1.59-1.44-18.17-17.47-19.82-19-4.29-4.06-7.93-4.56-12.85-3.88s-24.25,4.39-24.25,4.39,38.91,33.12,49.14,42c-1.9,6.92-16.73,51.94-16.73,51.94s15.53-2.12,20.7-3a16,16,0,0,0,11.5-8.58c.09-.18,4.88-15.5,10.81-34.57a12.1,12.1,0,0,0,2.47,5.1c1.85,2.41,16.24,20,16.4,20.15,4.38,4.52,7.8,4.77,11.85,4.2,0,0,12.66-2.15,13-2.23,4.58-1.06,7-3.16,9.48-8.79,1.57-3.39,20.89-59.19,20.89-59.19l-19.84,3.83c-6.34,1.11-7.82,4.51-8.63,6.08-1.81,4-10.71,30-14,39.58-2.45-3.07-21.21-26.92-24.65-31.28,1.63-5.22,3.23-10.4,4.78-15.35,2.93-.47,10.81-1.72,12.54-2-2.23,7-4.66,15.84-4.8,16.32a11.66,11.66,0,0,0,.74,8.37c1.42,3.25,12.67,14.5,12.67,14.5s13.14-35.51,16.38-43.23c2.19-.35,12.77-2.16,13.66-2.31,9.12-1.46,11.85-3.3,13.67-6.6,1.4-2.53,7.63-20.78,7.63-20.78S396.45,621.58,394.27,622Z",
    transform: "translate(-292.18 -597.2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.55,614.35l-15.79,2.74c-2.73.44-7.29,1.2-9,7.33-.87,3.3-11.41,34.87-11.41,34.87-.67.11-.79.06-1.11-.24-1.12-1-20.1-18.14-21.84-19.7-4.21-3.79-7.66-4-10.34-3.51l-18.54,3.23s37.21,31.77,46,39.47c-1.5,5.84-15.54,49.59-15.54,49.59s10-1.56,15.17-2.46a13.14,13.14,0,0,0,10.23-7.8Zm8.1,9.82c-2.72.48-7.12,4.57-8.41,7.81-1.17,2.95-4.62,12.6-4.62,12.6s10.47-1.66,13.63-2.2c-1.93,5.59-4.55,14.72-5.94,19.74a9.44,9.44,0,0,0,.62,6.86c1,2.47,9.81,11.73,9.81,11.73s12.56-34,15.93-41.85l15.94-2.66c6.83-1.22,9.06-2.38,10.52-5.42,1.18-2.46,5.3-15.8,5.3-15.8Zm27.58,26.24c-4.47.77-6,2.35-7,4.79-2,4.43-13,36.72-14.79,42.12-1,.21-1.3.21-2.49-1.46L374.9,666.48s-4.11,12.07-4.58,13.61c-.82,2.49-1.31,5,1.54,8.76,1.78,2.32,12.49,14.91,16.12,19,4,4.38,6.15,4.31,9.83,3.79l11.78-2c4.57-1,6.56-1.93,8.83-7,1.49-3.21,19-54.79,19-54.79Z",
    transform: "translate(-292.18 -597.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtv);
export default __webpack_public_path__ + "static/media/YTV.f67dc91537432ba169e357a3ea66d1b0.svg";
export { ForwardRef as ReactComponent };